/* eslint-disable */
export default {
  cancel: 'Abbrechen',
  reply: 'Antwort',
  onMyWay: 'Bin unterwegs',
  customMessage: 'Benutzerdefinierte Nachricht',
  callMeBackIn: 'Rufen Sie mich zurück in',
  willCallYouBackIn: 'Ich rufe Sie zurück in',
  min: 'Min.',
  hours: 'Stunden',
  days: 'Tage',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
